/**
 * Trata o payload do select de subplishers e injeta no body uma lista de subpublishers
 * @param {object} body - Objeto que representa o corpo da requisição
 * @param {object} data - Objeto que representa os dados do formulário
 */
type GenericSettings = { settings: Record<string, unknown> }

type HandleSubpublishers<T extends GenericSettings> = {
  body: T & SubpublishersCreateCampaign<T['settings']>
  data: SubpublisherScope
}

export const handleSubpublishers = <T extends GenericSettings>({
  body,
  data
}: HandleSubpublishers<T>) => {
  if (data?.subpublishers?.subpublishersCheck === 'selected') {
    const subpublishers = data?.subpublishers?.subpublisher_ids.filtered

    body.subpublishers = subpublishers
  }

  return body
}

export const mapToCampaignProducts = (products: PublisherProduct[]) => {
  return (
    products?.map(item => {
      const sku = item?.product_sku || item?.sku
      return {
        id: item?.id ? String(item.id) : undefined,
        sku: sku ? String(sku) : undefined,
        ...(!!item?.sub_publisher_id && {
          sub_publisher_id: item?.sub_publisher_id
        })
      }
    }) || null
  )
}

type AgeRestrictedSettings = {
  age_restricted?: boolean
}

export const mapAgeRestrictedSetting = (
  settings?: AgeRestrictedSettings | null
) => ({
  age_restricted: Boolean(settings?.age_restricted)
})

export function withDefaultAgeRestrictedSetting<
  T extends Record<string, unknown> = Record<string, never>
>(settings?: T): T & { age_restricted: boolean } {
  const baseSettings = (settings || {}) as T

  return {
    ...baseSettings,
    age_restricted: false
  }
}

/**
 *
 * @param destinations
 * @returns
 *
 *
 */
type DTOFormatDestinationsParams = {
  [key: string]: {
    brand: string
    publisher_id: string
    url: string
  }
}

export const DTOFormatDestinations = (
  destinations?: DTOFormatDestinationsParams
) => {
  if (!destinations) return null

  const payloadToArray = Object.values(destinations)

  if (!payloadToArray?.length) return null

  return payloadToArray
    .map(({ publisher_id, brand, url }) => {
      const destination: Partial<DestinationUrl> = {
        publisher_id,
        url: url?.trim()
      }
      if (brand) {
        destination.brand = brand
      }
      return destination as DestinationUrl
    })
    .filter(item => item.url)
}

/**
 * Handle additional assets banner video
 */
type HandleAdditionalAssetsBannerVideo = {
  body: DTOCreateBannerVideoCampaignResponse
  data: CreateCampaignBannerVideoFormData
}

export const handleAdditionalAssetsBannerVideo = ({
  body,
  data
}: HandleAdditionalAssetsBannerVideo) => {
  if (!data?.additional_assets) return body

  const additionalAssets = data.additional_assets.flat()
  const formattedAdditionalAssets = additionalAssets.map(asset => ({
    ...asset,
    width: Number(asset.width),
    height: Number(asset.height)
  }))

  body.settings.additional_assets = formattedAdditionalAssets

  return body
}
